'use client';

import { createContext, PropsWithChildren, useContext } from 'react';
import useMetaTags, { IUseMetaTags } from './useMetaTags';

const MetaTagsContext = createContext<IUseMetaTags | null>(null);

export const useMetaTagsContext = (): IUseMetaTags => {
  const context = useContext(MetaTagsContext);

  if (!context) {
    throw new Error('useMetaTagsContext must be used within a MetaTagsContextProvider');
  }

  return context;
};

const MetaTagsContextProvider = ({ children }: PropsWithChildren) => (
  <MetaTagsContext.Provider value={ useMetaTags() }>
    { children }
  </MetaTagsContext.Provider>
);

export default MetaTagsContextProvider;
